var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PSAreasActive')
}
var staticRenderFns = []

export { render, staticRenderFns }